import Api from './coreapi';
export default {
    invoiceHeader: {
        InvoiceType: '',
        CustomerId: '',
        CustomerName: '',
        CustomerTypeId: '',
        GrandTotal: 0,
        UntaxAmount: 0,
        ExchangeRate: 0,
        Description: '',
        PaymentTerm: 'Pay Later'
    },
    invoiceLine: {
        ItemId: '',
        ItemName: '',
        Quantity: 0,
        UomId: '',
        TaxLine: 10,
        TaxAmount: 0,
        Discount: 0,
        Cost: 0,
        Price: 0,
        SubTotal: 0,
        ExchangeRate: 4100,
    },
    getStockoutFromInvoice(filter){
        return new Promise((resolve) => {
            Api.request().post('sale/stockout-from-invoice', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    getReceiptFromInvoice(filter){
        return new Promise((resolve) => {
            Api.request().post('sale/receipt-from-invoice', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    selectInvoicePaid(filter){
        return new Promise((resolve) => {
            Api.request().post('invoice/paid', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    findInvoicePreview(filter){
        return new Promise((resolve) => {
            Api.request().post('invoice/preview', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    findReceiptPreview(filter){
        return new Promise((resolve) => {
            Api.request().post('sale/receipt-preview', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    findReceipt(filter){
        return new Promise((resolve) => {
            Api.request().post('sale/receipt-find', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    saveReceipt(model, isUpdate){
        let actionLink = isUpdate?'sale/receipt/update':'sale/receipt/save';
        return new Promise((resolve) => {
            Api.request().post(actionLink, model).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    deleteReceipt(filter){
        return new Promise((resolve) => {
            Api.request().post('receipt/cancel', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    reportSaleInvoiceList(filter){
        return new Promise((resolve) => {
            Api.request().post('invoice/report-sale', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    }
}